import { apiPath } from '@/lib/public-path';

function filenameFromDisposition(contentDisposition: string | null) {
  const match = contentDisposition?.match(/filename\*?=(?:UTF-8''|\")?([^\";]+)/i);
  return match?.[1] ? decodeURIComponent(match[1].trim()) : null;
}

/** Downloads a PDF returned by one of the local generate-pdf API routes. */
export async function downloadGeneratedPdf(
  endpoint: string,
  payload: unknown = {},
  fallbackFilename = "informe.pdf"
) {
  const response = await fetch(apiPath(endpoint), {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    throw new Error(`No se pudo generar el PDF: ${await response.text()}`);
  }

  const blob = await response.blob();
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filenameFromDisposition(response.headers.get("content-disposition")) || fallbackFilename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
}
